import React from 'react';
import { Unstable_NumberInput as NumberInput } from '@mui/base/Unstable_NumberInput';
import styles from './styles.module.scss';

interface ScoreSpinnerProps {
  value: number | string;
  onChange: (value: number) => void;
  label?: string;
  min?: number;
  max?: number;
  required?: boolean;
}

// Slot components live at module scope so their identity is stable across renders.
const Root = React.forwardRef<HTMLDivElement, any>(function Root({ ownerState: _ownerState, ...rest }, ref) {
  return <div {...rest} ref={ref} className={styles.root} />;
});

const Input = React.forwardRef<HTMLInputElement, any>(function Input({ ownerState: _ownerState, ...rest }, ref) {
  return <input {...rest} ref={ref} className={styles.input} readOnly tabIndex={-1} />;
});

const IncrementButton = React.forwardRef<HTMLButtonElement, any>(function IncrementButton({ ownerState: _ownerState, ...rest }, ref) {
  return (
    <button {...rest} ref={ref} type="button" className={styles.incrementBtn}>
      <span className={styles.btnIcon}>+</span>
    </button>
  );
});

const DecrementButton = React.forwardRef<HTMLButtonElement, any>(function DecrementButton({ ownerState: _ownerState, ...rest }, ref) {
  return (
    <button {...rest} ref={ref} type="button" className={styles.decrementBtn}>
      <span className={styles.btnIcon}>−</span>
    </button>
  );
});

const SLOTS = { root: Root, input: Input, incrementButton: IncrementButton, decrementButton: DecrementButton };

export const ScoreSpinner: React.FC<ScoreSpinnerProps> = ({
  value,
  onChange,
  label,
  min = 0,
  max = 20,
  required = false,
}) => {
  const numericValue = typeof value === 'string' ? (value === '' ? null : parseInt(value, 10)) : value;

  const handleChange = (
    _event: React.FocusEvent<HTMLInputElement> | React.PointerEvent | React.KeyboardEvent,
    val: number | null
  ) => {
    onChange(val ?? 0);
  };

  return (
    <div className={styles.wrapper}>
      {label && <div className={styles.label}>{label}</div>}
      <NumberInput
        value={numericValue}
        onChange={handleChange}
        min={min}
        max={max}
        required={required}
        slots={SLOTS}
      />
    </div>
  );
};

export default ScoreSpinner;
